export default {
    en: {
        "Incorrect Or Verification Question Answer": "Incorrect {{type}} Or Verification Question Answer",
        "verify_fail_message": "Sorry, we could not find the information that match our records. Try again or Whatsapps our customer service to help you",
    },
    "zh-hk": {
        "Account Created": "帳戶已建立",
        "Password Changed": "密碼重設",
        "Need a new account?": "需要一個新帳戶？",
        "Create an account": "建立新帳戶",
        "Login with member no.": "使用會員編號登入.",
        "Login": '登入',
        "Forgot password?": '忘記密碼？',
        "Phone No.": '電話號碼',
        "Password": '密碼',
        "Forget Password": '忘記密碼',
        "Welcome": "歡迎",
        "Back": "返回",
        "Already Existing Member?": "現有會員？",
        "Already a member? Transfer your point and account information now": "已經是會員？ 現在轉移您的積分和帳戶資料",
        "Transfer Existing Account": "轉移現有帳戶",
        "Please enter your phone no. to reset password": "請輸入您的電話號碼以重置密碼",
        "Verify Phone No.": "驗證電話號碼",
        "Verify Your Phone": "驗證您的電話號碼",
        "Please enter the OTP in the verification SMS": "請輸入驗證短信中的一次性密碼",
        "We have sent to": "我們已經發送到",
        "Re-enter your phone no.": "重新輸入您的電話號碼.",
        "Didn't get the SMS?": "沒有收到短信？",
        "Send Again": "重新發送",
        "Next": "下一頁",
        "Incorrect OTP filled. Please try again": "請輸入有效的驗證碼",
        "Reset Password": "重設密碼",
        "New Password": "新密碼",
        "Confirm Password": "確認密碼",
        "8-16 characters with numbers, upper and lower case": "密碼必須為 8-16 個字符，並包含大小寫字母和數字組合",
        "Change Password": "更改密碼",

        "Login Failed": "登入失敗",
        "Incorrect phone no. or password, please try again": "電話號碼不存在",

        "Please verify your identity with either phone no., email or member no.": "請用手機號碼，電郵地址或會員編號驗證您的身份。",
        "Verify With Member No.": "使用會員編號驗證.",
        "Verify With Phone No.": "使用電話號碼驗證.",
        "Verify With Email": "使用電郵地址驗證.",
        "2-step Authenication": "兩步驗證",
        "Please verify your identity with phone no.": "請使用電話號碼驗證您的身份",
        "Change verify method": "更改驗證方法",
        "Verify Account": "驗證帳戶",
        "Email Address": "電郵地址",
        "Member No.": "會員編號.",

        "Create a New Account": "建立新帳戶",
        "New an account or": "需要一個新帳戶？",


        "Last Name": "姓氏",
        "First Name": "名字",
        "Country/Region": "國家/地區",

        "Birth Date": "出生日期",
        "Optional": "可選填",
        "Gender": "性別",
        "Interests": "興趣",
        "Select your interests": "選擇您的興趣",
        "You can select max. 3 interests": "您最多可以選擇 3 個興趣",
        "I would like to receive email about news and promotion": "透過電郵收取最新消息和優惠",
        "I would like to receive promotion booklet": "透過郵寄收取優惠小冊子",
        "District": "地區",
        "Select your district": "選擇您的地區",
        "Detail Address": "詳細地址",

        "Create Account": "註冊帳戶",
        "By create account, you agree to our": "註冊帳戶，同意我們的",
        "Terms & Conditions": "條款及細則",

        "Year": "年",
        "Month": "月",
        "Male": "男",
        "Female": "女",
        "Invalid member no.": "無效的會員編號",
        "Answer below question to verifying the account": "請回答以下問題驗證帳戶",
        "Verification Question": "驗證問題",
        "Select your question": "選擇您的問題",
        "Update your extisting account profile": "更新您的現有帳戶資料",
        "Update Account": "更新帳戶",
        "Please fill in phone number": "請填寫電話號碼",
        "Please fill in only number": "請填寫數字",
        "Account Updated": "帳戶已更新",
        "Welcome back!": "歡迎回來！",
        "Hope you enjoy your experience in Overlander!": "希望您在 Overlander 有愉快的體驗！",
        "You have changed the password successfully!": "您已成功更改密碼！",
        "Go to Homepage": "前往首頁",
        "Login with phone no.": "使用電話號碼登入",
        "Member no.": "會員編號",
        "Please enter your member no.": "請輸入您的會員編號",
        "Call Us at +852 56901002": "致電我們 +852 56901002",
        "Incorrect Or Verification Question Answer": "{type}或驗證問題答案不正確",
        "Email": "電郵地址",
        "Invalid email address format": "無效的電郵地址格式",
        "Join": "加入",
        "Contact our customer service to help you transfer the account.": "聯絡我們的客服幫您轉移帳戶.",
        "If you encounter any problems when transferring your account, please contact us": "如在轉移帳戶上遇到問題，請聯絡我們",
        "Call Us at": "致電我們",
        "Need Help?": "需要協助？",

        "Please input your first name": "請輸入您的名字",
        "Please input your last name": "請輸入您的姓氏",
        "Please select your country/region": "請選擇您的國家/地區",
        "verify_fail_message": "抱歉，我們找不到與記錄相符的信息。請重試或WhatsApp聯絡我們的客服為你提供服務",
        "Verification": "驗證",
        "Please enter the verification code": "請輸入驗證碼",
        "recaptcha is required": "需要驗證碼",
    }

}
